import * as z from "zod";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum CountryCodeFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

const CountryCodeFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.COUNTRY_CODE,
  CountryCodeFilterQuery,
  z.array(z.string()),
);
export const CountryCodeFilterSchema: z.ZodType<CountryCodeFilter> =
  CountryCodeFilterSchema_;
export interface CountryCodeFilter extends z.infer<
  typeof CountryCodeFilterSchema_
> {}
